// Dependencies
//require('scrollmagic');
require('slick');

// Selectors
const
	$animationFadeUp = $('.js-fadeup'),
    $animationFadeRight = $('.js-faderight'),
    $animationFadeLeft = $('.js-fadeleft'),
    $animationFadeRightBounce = $('.js-fade-right-bounce'),
    $animationFadeLeftBounce = $('.js-fade-left-bounce'),
    $animationNumber = $('.js-number'),
    $animationStaggeredFadeHolder = $('.js-staggered-holder'),
    $animationStaggeredNumber = $('.js-staggered-number'),
    $animationStaggeredNumber2 = $('.js-staggered-number2'),
    $animationStaggeredNumber3 = $('.js-staggered-number3'),
    $animationStaggeredNumber4 = $('.js-staggered-number4'),
    $animationCircle = $('.js-fromto'),
    $animationHeight = $('.js-scroll-height'),
    $slideshow = $('.c-slideshow');


// Set count options
var numSimpleOpt = {
  useEasing : false, 
  useGrouping : true, 
  separator : ',', 
  decimal : '.', 
  prefix : '', 
  suffix : '' 
};

// Set counting data
const	numWind = new CountUp('num-wind', 43, 412, 0, .5, numSimpleOpt),
		numWindLarge = new CountUp('num-wind-large', 4035, 10678, 0, .5, numSimpleOpt),
		numSolar = new CountUp('num-solar', 0.1, 1.7, 1, .5, numSimpleOpt),
		numSolarLarge = new CountUp('num-solar-large', 233, 11043, 0, .5, numSimpleOpt),
		numApplications = new CountUp('num-applications', 0, 1000, 0, 1, numSimpleOpt),
		numTop = new CountUp('num-top', 0, 100, 0, 1, numSimpleOpt),
		numReduction = new CountUp('num-reduction', 0, 24, 0, 1, numSimpleOpt),
		numIncrease = new CountUp('num-increase', 0, 30, 0, 1, numSimpleOpt);

export default function init() {

    // Initialise the ScrollMagic controller
    let controller = new ScrollMagic.Controller({
        globalSceneOptions: {
            force3D: true
        }
    });

    // Create scene for every element

    // Scroll Height
    for (var i = 0; i < $animationHeight.length; i++) {
        let genericScrollHeight = new TweenMax.fromTo($animationHeight[i], 1,
        {
           height: 0,
        },
        {
           height: '100%',
        });

        new ScrollMagic.Scene({
            triggerElement: $animationHeight[i],
            triggerHook: "onEnter",
            reverse: false,
            duration: "50%",
        })
        .setTween(genericScrollHeight)
        .offset(80)
        .addTo(controller);
    }

    // Fade Up Animation
    for (var i = 0; i < $animationFadeUp.length; i++) {
        let genericFadeUp = new TweenMax.fromTo($animationFadeUp[i], .5,
        {
            y: 20,
            opacity: 0,
            scale: .98
        },
        {
            y: 0,
            opacity: 1,
            scale: 1
        });

        new ScrollMagic.Scene({
            triggerElement: $animationFadeUp[i],
            triggerHook: "onEnter",
            reverse: false
            //duration: "50%",
        })
        .setTween(genericFadeUp)
        .offset(100)
        .addTo(controller);
    }

    // Fade Right Animation
    for (var i = 0; i < $animationFadeRight.length; i++) {
        let genericFadeRight = new TweenMax.fromTo($animationFadeRight[i], .5,
        {
            x: -40,
            opacity: 0,
            scale: .98
        },
        {
            x: 0,
            opacity: 1,
            scale: 1
        });

        new ScrollMagic.Scene({
            triggerElement: $animationFadeRight[i],
            triggerHook: "onEnter",
            reverse: false,
            //duration: "50%",
        })
        .setTween(genericFadeRight)
        .offset(100)
        .addTo(controller);
    }

    // Fade Left Animation
    for (var i = 0; i < $animationFadeLeft.length; i++) {
        let genericFadeLeft = new TweenMax.fromTo($animationFadeLeft[i], .5,
        {
            x: 40,
            opacity: 0,
            scale: .98
        },
        {
            x: 0,
            opacity: 1,
            scale: 1
        });

        new ScrollMagic.Scene({
            triggerElement: $animationFadeLeft[i],
            triggerHook: "onEnter",
            reverse: false,
            //duration: "50%",
        })
        .setTween(genericFadeLeft)
        .offset(100)
        .addTo(controller);
    }

    // Fade Left Bounce Animation
    for (var i = 0; i < $animationFadeLeftBounce.length; i++) {
        let genericFadeLeftBounce = new TimelineMax()
		.to($animationFadeLeftBounce[i], 0,      
        {
            x: -50,
            opacity: 0,
            scale: .98
        })
		.to($animationFadeLeftBounce[i], .3, 
        {
            x: 30,
            opacity: 1,
            scale: 1,
        })
        .to($animationFadeLeftBounce[i], .3, 
        {
            x: 0,
          
        });

        new ScrollMagic.Scene({
            triggerElement: $animationFadeLeftBounce[i],
            triggerHook: "onEnter",
            reverse: false,
            bounce: true,
            //duration: "50%",
        })
        .setTween(genericFadeLeftBounce)
        .offset(100)
        .addTo(controller);
    }

    // Fade Right Bounce Animation
    for (var i = 0; i < $animationFadeRightBounce.length; i++) {
        let genericFadeRightBounce = new TimelineMax()
		.to($animationFadeRightBounce[i], 0,      
        {
            x: 50,
            opacity: 0,
            scale: .98
        })
		.to($animationFadeRightBounce[i], .3, 
        {
            x: -30,
            opacity: 1,
            scale: 1,
        })
        .to($animationFadeRightBounce[i], .3, 
        {
            x: 0,
          
        });

        new ScrollMagic.Scene({
            triggerElement: $animationFadeRightBounce[i],
            triggerHook: "onEnter",
            reverse: false,
            bounce: true,
            //duration: "50%",
        })
        .setTween(genericFadeRightBounce)
        .offset(100)
        .addTo(controller);
    }

    // Staggered fade
    function staggered(element, tween){
        var tween = new TimelineMax()
        .staggerFrom(element, .5,
            {
                y: 20,
                opacity: 0,
                scale: .98}, .25)
        .staggerTo(element, .25,
            {
                y: 0,
                opacity: 1,
                scale: 1}, .1);
        let scene = new ScrollMagic.Scene({
            triggerElement: element,
            triggerHook: "onEnter",
            //duration: "50%",
        })
        .setTween(tween)
        .offset(100)
        .addTo(controller);
    }

    staggered('.js-staggered', 'stagger1');

    // Cricle that grows and counts up
    function circle(element, circle, text, figure, tween, count){
        var tween = new TimelineMax()
        .fromTo(circle, .5,
        {
            opacity: 1,
            fill: 'rgba(54, 15, 60, 0)'
        },
        {	
             opacity: 1,
             fill: 'rgba(54, 15, 60, .6)'
        }, .5)
        .fromTo(text, .5,
        {
            maxWidth: '200px',
            onUpdate:function() {
                count.reset();
            }
        },
        {
            maxWidth: '270px',
            onUpdate:function() {
               count.start();
            }
        }, .5)
        .fromTo(figure, .5,
        {
            fontSize: '0px',
        },
        {
            fontSize: '86px',
        }, .5)
        new ScrollMagic.Scene({
            triggerElement: element,
            triggerHook: "onEnter",
            reverse: false,
        })
        .setTween(tween)
        .offset(100)
        .addTo(controller);
    }

    // Circle with shadows and counts up
    function circleAlt(element, text, tween, count){
        var tween = new TimelineMax()
        .fromTo(text, .5,
        {
        	background: 'rgba(54, 15, 60, 0)',
            onUpdate:function() {
                count.reset();
            }
        },
        {
        	background: 'rgba(54, 15, 60, 1)',
        	boxShadow: '0 0 0 15px rgba(255,255,255,0.4), 0 0 0 30px rgba(255,255,255,0.1), 0 0 0 45px rgba(255,255,255,0.1)',
            onUpdate:function() {
               count.start();
            }
        }, .5);
        new ScrollMagic.Scene({
            triggerElement: element,
            triggerHook: "onEnter",
            reverse: false,
        })
        .setTween(tween)
        .offset(100)
        .addTo(controller);
    }

    circle('.js-fromto', '.js-fromto-circle', '.js-fromto-text', '.js-fromto-figure', 'circle', numWind);
    circle('.js-fromto2', '.js-fromto-circle', '.js-fromto-text', '.js-fromto-figure', 'circle', numSolar);
    circleAlt('.js-fromtoalt', '.js-fromtoalt-text', 'circle', numWindLarge);
    circleAlt('.js-fromtoalt2', '.js-fromtoalt-text', 'circle', numSolarLarge);

    

    function slideshowStat(element, text, tween, initVal, count){	
        var tween = new TimelineMax()
        .fromTo(text, .5,
        {
            onUpdate:function() {
            	if (!$(element).hasClass('is-exectued')) {
                	count.reset();
            	}
            	if ($(element).hasClass('is-exectued')) {
            		$(element).text(initVal);
            	}
            }
        },
        {
            onUpdate:function() {
            	if (!$(element).hasClass('is-exectued')) {
               		count.start();
            	    $(element).addClass('is-exectued');
           		}
            }
        }, 0);
        new ScrollMagic.Scene({
            triggerElement: element,
            triggerHook: "onEnter",
            reverse: false,
        })
        .setTween(tween)
        .offset(100)
        .addTo(controller);
    }

    // Slide Show
    function slideshow(element){	
	    new ScrollMagic.Scene({
	    	triggerElement: element,
	    	reverse: false,
	    })
	    .setClassToggle(element + " .slick-active", "is-active")
	    .offset(100)
	    .addTo(controller);
	}

	slideshow('.js-slideshow-gas');
	slideshow('.js-slideshow-electricity');


    // Pinned Header
	new ScrollMagic.Scene({
		triggerElement: '.c-header',
		triggerHook: "onLeave",
		reverse: true,
		duration: 0,
	})
	.setPin('.c-header', {pushFollowers: false})
	.setClassToggle('.c-header', 'is-pinned')
	.addTo(controller);


	// Stats slideshow to add number counting
	$('.js-slick-stats').on('init', function(event, slick) {
		slideshowStat('.js-countup-applications', '.js-countup-applications', 'slideshowStat', '1000', numApplications);
    	slideshowStat('.js-countup-top', '.js-countup-top', 'slideshowStat', '75', numTop);
	})
	$('.js-slick-stats').slick({
		// global 
		speed: 300,
	  	infinite: true,
	  	adaptiveHeight: false,
	  	slide: '.js-slide',
		arrows: true,
		dots: true,
	  	nextArrow: '<button class="slick-next"><svg><use xlink:href="#chevron"></use></svg></button>',
	  	prevArrow: '<button class="slick-prev"><svg><use xlink:href="#chevron"></use></svg></button>',
	
	}).on('afterChange', function(event, slick) {
    	slideshowStat('.js-countup-reduction', '.js-countup-reduction', 'slideshowStat', '24', numReduction);
    	slideshowStat('.js-countup-increase', '.js-countup-increase', 'slideshowStat', '30', numIncrease);
    	slideshowStat('.js-countup-applications', '.js-countup-applications', 'slideshowStat', '1000', numApplications);
    	slideshowStat('.js-countup-top', '.js-countup-top', 'slideshowStat', '75', numTop);
	});

	// Scroll to top
	// change behaviour of controller to animate scroll instead of jump
	controller.scrollTo(function(target) {
		TweenMax.to(window, 1, {
		    scrollTo : {
		      y: target, // scroll position of the target along y axis
		      autoKill: true // allows user to kill scroll action smoothly
		    },
		    ease : Cubic.easeInOut
		});
	});

	//  Bind scroll to anchor links
	$(document).on("click", "a[href^=#]", function(e) {
	  var id = $(this).attr("href");

	  if($(id).length > 0) {
	    e.preventDefault();
	    // trigger scroll
	    controller.scrollTo(id);
	  }

	});

}